import { useMemo } from 'react';
import { useKnowledges } from './useKnowledges';
import { useCompanyChatAgents } from './useCompanyChatAgents';
import {
  ChatAgent,
  ChatAgentWithAttachedKnowledge,
} from '../../interfaces/ChatAgent';
import Knowledge from '../../interfaces/Knowledge';

export const useChatAgentsWithKnowledge = (
  userId: string | undefined,
  enabled = true
) => {
  const {
    data: chatAgents,
    isLoading: agentsLoading,
    error: agentsError,
  } = useCompanyChatAgents(enabled);

  const {
    data: knowledgesData,
    isLoading: knowledgesLoading,
    error: knowledgesError,
  } = useKnowledges(userId, enabled);

  const chatAgentsWithKnowledge =
    useMemo((): ChatAgentWithAttachedKnowledge[] => {
      if (!chatAgents || !knowledgesData?.message) {
        return [];
      }

      const knowledges = knowledgesData.message as Knowledge[];
      const knowledgesMap = new Map<string | undefined, Knowledge>(
        knowledges.map((k: Knowledge) => [k.id, k])
      );

      return chatAgents.map((agent: ChatAgent) => ({
        ...agent,
        attachedKnowledge: knowledgesMap.get(agent.knowledge_ids?.[0]),
      }));
    }, [chatAgents, knowledgesData?.message]);

  return {
    data: chatAgentsWithKnowledge,
    isLoading: agentsLoading || knowledgesLoading,
    error: agentsError || knowledgesError,
    agentsCount: chatAgents.length,
  };
};
